<template>
    <div class="convention-ca-activity">
        <convention-body v-if="activity.type == 'text'" :body="activity.body" />
        <div class="convention-body" v-if="activity.type == 'group'">
            <table>
                <tr>
                    <th class="code">Code</th>
                    <th>Activité</th>
                </tr>
                <convention-ca-activity-item
                    v-for="item in activity.items"
                    :item="item"
                    :key="item._uid"
                    :apenafs="apenafs"
                    :isExcluded="isExcluded(item)"
                />
            </table>
        </div>
    </div>
</template>

<script>
import ConventionCaActivityItem from "./ConventionCaActivityItem.vue";
import ConventionBody from "src/components/convention/ConventionBody.vue";
import { isArray } from "lodash";

export default {
    components: { ConventionBody, ConventionCaActivityItem },
    props: ["activity", "apenafs", "excludedActivitiesCodes"],
    methods: {
        isExcluded(item) {
            return isArray(this.excludedActivitiesCodes)
                ? this.excludedActivitiesCodes.indexOf(item.code) !== -1
                : false;
        },
    },
};
</script>

<style scoped lang="sass">
.code
    width: 20%
</style>
